
import _ from "lodash"
import { Drawer } from "element-ui"
import drawerHeader from "./components/drawerHeader.vue"
import addressAction from "@/components/address/addressAction.vue"
export default {
  components: {
    [Drawer.name]: Drawer,
    drawerHeader,
    addressAction
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "add"
    },
    addresses: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curVisible: this.visible,
      activeItem: {},
      oldActiveItem: {},
      addressObj: null
    }
  },
  computed: {
    isSaveDisabled() {
      if (this.isAddressActive(this.activeItem, this.oldActiveItem)) {
        return true
      }
      return false
    },
    title() {
      return this.type == "add" ? this.$t("address.addNewAddress") : this.$t("address.editAddress")
    }
    // addressObj(){
    //   return this.addresses || null
    // }
  },
  watch: {
    visible(val) {
      if (val) {
        this.addressObj = this.addresses || null
      }
      this.curVisible = val
    }
  },
  methods: {
    handleClose(param) {
      this.$emit("close", param)
    },
    handleSelect(item, index) {
      this.activeItem = item
    },
    handleSave() {
      this.$emit("save", this.activeItem)
      this.handleClose()
    },
    handleBack() {
      this.$emit("back")
    },

    handleAddressUpdate() {
      this.$emit("update")
    }
  }
}
